module.exports = __webpack_public_path__ + "static/media/fourth-block-img1.083b4bf9.svg";